
import { defineComponent, Ref, inject } from "vue";
import CloseSVG from "@/components/CloseSVG.vue";

export default defineComponent({
  name: "Contact",
  components: {
    CloseSVG,
  },
  setup(_) {
    const closeModal = inject("closeModal") as () => void;
    const bounceTransition = inject("bounceTransition") as Ref<string>;
    const fadeTransition = inject("fadeTransition") as Ref<string>;

    return {
      closeModal,
      bounceTransition,
      fadeTransition,
    };
  },
});
